var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Desktop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.832,
    height: 31.098,
    viewBox: "0 0 136.832 31.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-Games-Thumbnail-Copy-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Amusnet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M110.789,48.021h1.278V40.443h-1.278Z",
    transform: "translate(-58.587 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M125.941,40.443h1.278v7.578h-1.387l-4.291-5.529v5.529h-1.278V40.443h1.278l4.4,5.659Z",
    transform: "translate(-63.597 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M143.844,41.614v6.407h-1.278V41.614h-2.3V40.443h5.873v1.171Z",
    transform: "translate(-74.176 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M163.3,40.443v1.2h-4.042v2.006h3.63v1.138h-3.63v2.027h4.171v1.2h-5.45V40.443Z",
    transform: "translate(-83.539 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M179.658,43.978a1.351,1.351,0,0,0,.39-1.078,1.154,1.154,0,0,0-.4-1.019,2.665,2.665,0,0,0-1.43-.276h-1.626v2.71h1.593a2.338,2.338,0,0,0,1.474-.336m1.7-1.073a2.2,2.2,0,0,1-1.636,2.363l1.983,2.754H180.08l-1.81-2.548h-1.68v2.548h-1.278V40.443h2.817a4.077,4.077,0,0,1,2.481.586,2.235,2.235,0,0,1,.748,1.875",
    transform: "translate(-92.708 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M197.518,45.116l-1.376-3.122-1.376,3.122ZM194.246,46.3l-.758,1.724h-1.365l3.337-7.578h1.365l3.337,7.578H198.8l-.758-1.724Z",
    transform: "translate(-101.597 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M216.624,46.655a2.672,2.672,0,0,0,1.138-.222,3.92,3.92,0,0,0,1-.71l.823.846a3.789,3.789,0,0,1-2.92,1.334,3.913,3.913,0,0,1-2.849-1.106,4.02,4.02,0,0,1,.021-5.616,4,4,0,0,1,2.915-1.127,3.81,3.81,0,0,1,2.942,1.3l-.812.889a3.554,3.554,0,0,0-1.024-.726,2.869,2.869,0,0,0-1.132-.206,2.692,2.692,0,0,0-1.929.742,2.5,2.5,0,0,0-.78,1.9,2.62,2.62,0,0,0,.775,1.93,2.509,2.509,0,0,0,1.837.775",
    transform: "translate(-112.468 -21.181)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M235,41.614v6.407h-1.278V41.614h-2.3V40.443h5.873v1.171Z",
    transform: "translate(-122.379 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M249.128,48.021h1.278V40.443h-1.278Z",
    transform: "translate(-131.742 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M260.915,48.021h-1.43l-3.045-7.578h1.43L260.2,46.1l2.329-5.659h1.43Z",
    transform: "translate(-135.609 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M282.318,40.443v1.2h-4.042v2.006h3.63v1.138h-3.63v2.027h4.171v1.2H277V40.443Z",
    transform: "translate(-146.48 -21.387)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M9.18,15.907c.037-4.157,3.96-9.5,10.647-12.426,11.768-5.145,18.51-.4,20.255,4.083,1.626,4.18-1.59,11.519-7.161,16.987A44.369,44.369,0,0,0,42.4,15.663c2.989-3.947,4.227-7.742,3.091-10.688C43.811.623,37.253-.776,28.939.4A62.463,62.463,0,0,0,9.112,6.219C3.407,9.12.462,12.565.042,16.5c-.611,5.709,5.5,13.383,19.489,14.329,7.35.5,14.4.663,28.05-2.652-1.626.052-38.55,4.641-38.4-12.266",
    transform: "translate(0 0)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M39.377,30a7.958,7.958,0,1,0-7.954-7.958A7.971,7.971,0,0,0,39.377,30",
    transform: "translate(-16.617 -7.447)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M117.35,15.051l-1.314-3.272-1.314,3.272Zm.847,2.133h-4.322l-.8,1.987h-2.949l4.512-10.226h2.847l4.526,10.226H119Z",
    transform: "translate(-58.234 -4.73)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    d: "M149,19.171l-.029-5.42-2.628,4.412h-1.285L142.448,13.9v5.274h-2.672V8.945h2.38l3.591,5.9,3.5-5.9h2.38l.029,10.226Z",
    transform: "translate(-73.916 -4.73)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M173.11,18.134a4.716,4.716,0,0,1-1.263-3.521V8.945h2.891v5.58q0,2.454,1.942,2.454t1.927-2.454V8.945h2.847v5.668a4.716,4.716,0,0,1-1.263,3.521,5.669,5.669,0,0,1-7.081,0",
    transform: "translate(-90.875 -4.731)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    d: "M199.463,18.839a5.919,5.919,0,0,1-1.9-.818l.949-2.133a6.13,6.13,0,0,0,1.591.731,6.058,6.058,0,0,0,1.781.278q1.664,0,1.664-.833a.689.689,0,0,0-.474-.65,8.734,8.734,0,0,0-1.526-.446,14.563,14.563,0,0,1-1.927-.533,3.241,3.241,0,0,1-1.328-.913,2.467,2.467,0,0,1-.555-1.695,2.935,2.935,0,0,1,.511-1.687,3.42,3.42,0,0,1,1.526-1.191,6.273,6.273,0,0,1,2.489-.438,8.778,8.778,0,0,1,1.986.226,6.086,6.086,0,0,1,1.723.665l-.891,2.147a5.948,5.948,0,0,0-2.833-.789,2.376,2.376,0,0,0-1.256.256.767.767,0,0,0-.394.665.659.659,0,0,0,.467.614,8.443,8.443,0,0,0,1.5.424,14.079,14.079,0,0,1,1.935.533,3.338,3.338,0,0,1,1.328.906,2.421,2.421,0,0,1,.562,1.687,2.878,2.878,0,0,1-.511,1.665,3.484,3.484,0,0,1-1.533,1.191,6.2,6.2,0,0,1-2.482.446,9.448,9.448,0,0,1-2.409-.307",
    transform: "translate(-104.475 -4.501)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M231.551,8.945V19.171h-2.38l-4.512-5.449v5.449h-2.832V8.945h2.38l4.511,5.449V8.945Z",
    transform: "translate(-117.306 -4.73)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    d: "M257.7,16.936v2.235H249.5V8.945h8.016V11.18H252.36V12.9H256.9v2.162H252.36v1.87Z",
    transform: "translate(-131.938 -4.73)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M274.111,11.239h-3.139V8.945h9.154v2.294H277v7.932h-2.891Z",
    transform: "translate(-143.294 -4.73)",
    fill: "#a5cd39",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.137dce6bb4c39545738cb95172b766f1.svg";
export { ForwardRef as ReactComponent };